import request from '@/utils/request'
import { ApiResponse } from './types'

/**
 * 导航菜单
 */
export enum NavMenuPosition {
  Header = 0,
  Footer = 1
}

export enum MenuItemLinkType {
  None = 0,
  Inner = 1,
  Outer = 2
}

export interface MenuItem {
  id: number
  menuName: string
  menuIcon?: string
  parentMenuId?: number
  linkType?: MenuItemLinkType
  linkContent?: string
  children?: MenuItem[]
}

export interface NavMenusResponse {
  menuIds: number[]
  menuList: MenuItem[]
}

export const queryNavMenusReq = async (
  position: NavMenuPosition
): Promise<MenuItem[] | undefined> => {
  const res = await request.post<ApiResponse<NavMenusResponse>>(
    '/api/portalWebsiteSvcExt/navMenus',
    {
      position
    }
  )

  const menuMap = new Map<number, MenuItem>()
  const menuList = res.data?.result?.menuList || []
  const resultList: MenuItem[] = []

  menuList.forEach((menu) => {
    menu.children = []
    menuMap.set(menu.id, menu)
  })

  menuList.forEach((menu) => {
    if (menu.parentMenuId) {
      menuMap.get(menu.parentMenuId)?.children?.push(menu)
    } else {
      resultList.push(menu)
    }
  })
  return resultList
}

/**
 * 获取政策
 */
export enum GetPortalPolicyInput {
  Privacy = 1, // 隐私说明
  Service = 2, // 服务政策
  Agreement = 3 // 使用协议
}

export interface PortalPolicyResponse {
  title: string
  summary: string
  type: GetPortalPolicyInput
  detail: string
}

export const queryHeaderNavMenusReq = async (type: GetPortalPolicyInput) => {
  return request.post<ApiResponse<PortalPolicyResponse>>('/api/portalWebsiteSvcExt/portalPolicy', {
    type
  })
}

/**
 * 获取门户站配置
 */
// 配置项输出
export interface PortalConfigOutputDto {
  configName: string
  configKey: string
  configValue: string
  description?: string
  sortNum?: number
}

// 配置结果
export interface PortalConfigResultDto {
  configList: PortalConfigOutputDto[]
}

// 查询门户站配置
export const queryPortalConfigReq = async (groupName?: string) => {
  return request.post<ApiResponse<PortalConfigResultDto>>(
    '/api/portalWebsiteSvcExt/portalConfigs',
    { groupName }
  )
}


export interface PageOutputDto {
  id: number
  pageCode: string
  pageName: string
}

export interface PageListResponse {
  pageList: PageOutputDto[]
}

export const queryPagesReq = async () => {
  return request.post<ApiResponse<PageListResponse>>('/api/portalWebsiteSvcExt/pages')
}
